import dayjs from 'dayjs'
import FormOrder from '../../../../../types/api/form-order'
import FormSet from '../../../../../types/api/form-set'
import { getAvailabilityFromOrder } from './common'
import { AvailabilityDisplay } from './types'

function getLastFormOrder(formSet?: FormSet): FormOrder | undefined {
    const forms = formSet?.forms
    if (!forms?.length) return undefined

    const formsWithOrder = forms.filter(form => form.form_order)
    if (!formsWithOrder.length) return undefined

    const formWithoutDate = formsWithOrder.find(form => !form.form_order?.estimatedDate)
    if (formWithoutDate?.form_order) return formWithoutDate.form_order

    return formsWithOrder.reduce((latest, current) => {
        const latestDate = dayjs(latest.form_order!.estimatedDate!)
        const currentDate = dayjs(current.form_order!.estimatedDate!)
        return currentDate.isAfter(latestDate) ? current : latest
    }).form_order
}

export function getFormsAvailabilityStatus(formSet?: FormSet): AvailabilityDisplay {
    return getAvailabilityFromOrder(getLastFormOrder(formSet), {
        missing: 'Формы не заказаны',
        notOrderedInfo: 'Создана заявка на заказ',
    })
}
